import { render, staticRenderFns } from "./SendResetPasswordEmailButton.vue?vue&type=template&id=71c003da&"
import script from "./SendResetPasswordEmailButton.vue?vue&type=script&lang=js&"
export * from "./SendResetPasswordEmailButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports